import client from './client';

export default (function BumpGroupsService() {
  let service;

  if (!service) {
    service = client.service('bumpGroups');
  }

  return service;
}());
